<template>
  <div>
    <v-layout column v-if="isRouteAuthorized">
      <v-flex v-if="showHeaderCard">
        <!-- TODO: Used skeleton while loading for the first time -->
        <Header :theme="getGeneralState('theme_dark')" :date='active.Date' />
      </v-flex>
      <v-flex>
        <router-view />
      </v-flex>
    </v-layout>
    <NoDevice message="Sorry!! You do not have access to this feature." v-else></NoDevice>
    <div v-if="showFilter" id="mySidenav"
      :class="{'open-sidenav': open, 'originalIconColor': !isFilterDisabled, 'disabled': isFilterDisabled}"
      @click="slideFilterHandler">
      <img class="icon" src="@/assets/filter2.svg" alt="filter">
    </div>
    <FilterModule v-if="!isFilterDisabled" :filterProps="filterProps" :active="active"
      :open="open" @change:state="value => {open = value}" @changeFilterOption="changeFilterOption"
      @updateFilter="updateJustTheFilter" />
  </div>
</template>

<script>
import {
  EventBus
} from '@/services/event-bus'
import { mapGetters, mapMutations } from 'vuex'
import FilterModule from '@/components/Filter/FilterModule'
import _ from 'lodash'
const Header = () => import('@/components/dashboard-inverter/Header')
const NoDevice = () => import('@/components/utility/NoDevice.vue')
const momentTz = require('moment-timezone')

export default {
  components: {
    FilterModule,
    Header,
    NoDevice
  },
  data() {
    return {
      open: false,
      currentWidth: null,
      power: 0.0,
      startDate: '',
      endDate: '',
      modifiedDashboardName: ''
    }
  },
  computed: {
    ...mapGetters('report', ['getSelectedTemplate', 'getRanges']),
    ...mapGetters(['getDashboardList', 'getGeneralState', 'getActivePlantInfo', 'getFilterOptions', 'getShowHeaderCards', 'showDisabledFilter']),
    showHeaderCard() {
      return this.getShowHeaderCards(this.$route.name)
    },
    showFilter() {
      return !this.showDisabledFilter(this.$route.name)
    },
    filterProps() {
      let dashboardName = this.$route.name + this.modifiedDashboardName
      return _.cloneDeep(this.getFilterOptions[dashboardName])
    },
    active() {
      return this.getGeneralState('activeFilterOption')
    },
    isRouteAuthorized() {
      return this.getDashboardList.some(item => item.path === this.$route.path)
    },
    isFilterDisabled() {
      return _.isEmpty(this.active)
    }
  },
  mounted() {
    EventBus.$on('filter_disruptor', this.filterDisruptor)
    this.onResize()
    window.addEventListener('resize', this.onResize)
    this.startDate = momentTz().tz(this.getActivePlantInfo('timezone')).format('YYYY-MM-DD')
    this.endDate = momentTz().tz(this.getActivePlantInfo('timezone')).format('YYYY-MM-DD')
  },
  beforeUnmount() {
    EventBus.$off('filter_disruptor', this.filterDisruptor)
    window.removeEventListener('resize', this.onResize)
  },
  methods: {
    ...mapMutations(['SET_ACTIVE_FILTER', 'SET_UPDATE_FILTER_DB']),
    slideFilterHandler() {
      if (!this.isFilterDisabled) {
        this.open = true
      }
    },
    changeFilterOption(value) {
      this.SET_ACTIVE_FILTER(value)
    },
    updateJustTheFilter(payload) {
      const newActive = {}
      newActive[payload['key']] = payload['value']
      this.SET_ACTIVE_FILTER(newActive)
    },
    filterDisruptor(val) {
      this.modifiedDashboardName = val.name
    },
    onResize(event) {
      this.currentWidth = window.innerWidth
    }
  }
}
</script>

<style scoped>
#mySidenav {
  top: 64px;
  position: fixed;
  right: -12px;
  transition: 0.2s;
  width: 47px;
  text-decoration: none;
  font-size: 20px;
  color: white;
  border-radius: 5px 0 0 5px;
  z-index: 11;
}

.originalIconColor {
  background-color: #fbbc05;
}

.originalIconColor:hover {
  cursor: pointer;
}

#mySidenav .icon:hover {
  right: 0;
  transform: scale(1.2);
}

.open-sidenav {
  right: 390px !important;
}

.icon {
  height: 16px;
  width: 24px;
  margin-top: 8px;
  margin-left: 4px;
}

.disabled {
  background-color: #ffe492;
}

.disabled:hover {
  cursor: not-allowed;
}
</style>
